<template>
    <VJoyWrapper align="center" wrap="nowrap" class="profile-appraisal-hidden-indicator">
        <VJoyIcon name="eye-masked" color="neutral" size="small" />
        <span>{{ t('profile.hidden.appraisals.count', {accountFirstName: accountFirstname, nbrHiddenAppraisals: hiddenCounter}) }}</span>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyIcon, VJoyWrapper} from '@maltjoy/core-vue';

    type Props = {
        accountFirstname: string;
        hiddenCounter: number;
    };
    defineProps<Props>();
    const {t} = useTranslation();
</script>
